<template>
  <div class="sub-page-v2">
    <div class="page-hero-small">
      <h1>{{ $t('mail.title') }}</h1>
    </div>
    <div class="container-v2 page-body-v2">
      <div class="mail-card-v2">
        <div class="mail-icon">✉</div>
        <h3>{{ $t('mail.heading') }}</h3>
        <p>{{ $t('mail.text') }}</p>
        <a :href="mailUrl" target="_blank" class="btn-primary">{{ $t('mail.button') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getSiteConfig } from '@/api/portal'

export default {
  name: 'MailV2',
  data() {
    return {
      mailUrl: 'mailto:cseesbl@163.com'
    }
  },
  created() {
    getSiteConfig().then(data => {
      if (data && data.mailUrl) {
        this.mailUrl = data.mailUrl
      }
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.mail-card-v2 {
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
  border-radius: 24px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0,0,0,0.08);

  .mail-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #3b82f6, #06b6d4);
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 30px;
    color: #fff;
    font-size: 36px;
  }

  h3 {
    font-size: 24px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 12px;
  }

  p {
    font-size: 16px;
    color: #64748b;
    margin-bottom: 30px;
  }
}

.btn-primary {
  display: inline-block;
  padding: 14px 40px;
  background: linear-gradient(135deg, #3b82f6, #06b6d4);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  transition: all 0.3s;
  box-shadow: 0 4px 20px rgba(59,130,246,0.4);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(59,130,246,0.5);
  }
}
</style>
